<template>
  <form v-on:submit="submit" id="createResourceForm" novalidate>
    <div class="form-group">
      <label for="title">Title</label>
      <input
        v-model="resourceData.title"
        type="text"
        class="form-control"
        id="title"
        placeholder="Title"
        required
      />
      <div class="valid-feedback">Looks good!</div>
    </div>

    <div class="form-group">
      <label>Location</label>
      <v-select
        :options="locations"
        v-model="resourceData.location"
        placeholder="Click to Select Location"
        label="name"
      />
    </div>

    <div class="form-group">
      <label for="type">Type</label>
      <v-select
        :options="['General', 'Addiction', 'Skills Training', 'Clothing', 'Legal', 'Financial', 'Identity', 'Food', 'Housing', 'Mental Health', 'Healthcare', 'Transportation']"
        placeholder="Click to select type"
        v-model="resourceDataType"
        :clearable="false"
        label="type"
        :style="typeSelectorStyle"
      />
      <div class="valid-feedback">Looks good!</div>
    </div>

    <div class="form-group">
      <label for="description">Description</label>
      <div class="editor">
        <editor-menu-bar :editor="editor" v-slot:default="editorParams">
          <div class="border rounded-top">
            <div class="btn-toolbar p-2" role="toolbar" aria-label="Editor Toolbar">
              <div class="btn-group btn-group-sm mr-2" role="group">
                <editor-menu-button command="bold" :editor-params="editorParams" />
                <editor-menu-button command="italic" :editor-params="editorParams" />
                <editor-menu-button command="underline" :editor-params="editorParams" />
                <editor-menu-button
                  command="strike"
                  icon="strikethrough"
                  :editor-params="editorParams"
                />
              </div>
              <div class="btn-group btn-group-sm mr-2" role="group">
                <editor-menu-button command="paragraph" :editor-params="editorParams" />
                <editor-menu-button
                  command="heading"
                  :args="{ level: 1 }"
                  :editor-params="editorParams"
                >H1</editor-menu-button>
                <editor-menu-button
                  command="heading"
                  :args="{ level: 2 }"
                  :editor-params="editorParams"
                >H2</editor-menu-button>
                <editor-menu-button
                  command="heading"
                  :args="{ level: 3 }"
                  :editor-params="editorParams"
                >H3</editor-menu-button>
                <editor-menu-button
                  command="bullet_list"
                  icon="list-ul"
                  :editor-params="editorParams"
                />
                <editor-menu-button
                  command="ordered_list"
                  icon="list-ol"
                  :editor-params="editorParams"
                />
              </div>
            </div>
          </div>
        </editor-menu-bar>

        <editor-content class="editor__content p-2" :editor="editor" />
      </div>
    </div>
    <div class="form-group">
      <label for="description">How to Access</label>
      <div class="editor">
        <editor-menu-bar :editor="editor2" v-slot:default="editorParams2">
          <div class="border rounded-top">
            <div class="btn-toolbar p-2" role="toolbar" aria-label="Editor Toolbar">
              <div class="btn-group btn-group-sm mr-2" role="group">
                <editor-menu-button command="bold" :editor-params="editorParams2" />
                <editor-menu-button command="italic" :editor-params="editorParams2" />
                <editor-menu-button command="underline" :editor-params="editorParams2" />
                <editor-menu-button
                  command="strike"
                  icon="strikethrough"
                  :editor-params="editorParams2"
                />
              </div>
              <div class="btn-group btn-group-sm mr-2" role="group">
                <editor-menu-button command="paragraph" :editor-params="editorParams2" />
                <editor-menu-button
                  command="heading"
                  :args="{ level: 1 }"
                  :editor-params="editorParams2"
                >H1</editor-menu-button>
                <editor-menu-button
                  command="heading"
                  :args="{ level: 2 }"
                  :editor-params="editorParams2"
                >H2</editor-menu-button>
                <editor-menu-button
                  command="heading"
                  :args="{ level: 3 }"
                  :editor-params="editorParams2"
                >H3</editor-menu-button>
                <editor-menu-button
                  command="bullet_list"
                  icon="list-ul"
                  :editor-params="editorParams2"
                />
                <editor-menu-button
                  command="ordered_list"
                  icon="list-ol"
                  :editor-params="editorParams2"
                />
              </div>
            </div>
          </div>
        </editor-menu-bar>

        <editor-content class="editor__content p-2" :editor="editor2" />
      </div>
    </div>

    <div class="form-group">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" value id="invalidCheck" required />
        <label class="form-check-label" for="invalidCheck">Agree to terms and conditions</label>
        <div class="invalid-feedback">You must agree before submitting.</div>
      </div>
    </div>
    <button class="btn btn-primary" type="submit">Submit form</button>
  </form>
</template>

<script>
window.$ = window.jQuery = require("jquery");
import firebase from "@/config/firebase.js";
import { firestorage } from "@/config/firebase.js";
require("bootstrap/dist/js/bootstrap.js");

import "flatpickr/dist/flatpickr.css";

import { Editor, EditorContent, EditorMenuBar } from "tiptap";
import EditorMenuButton from "./EditorMenuButton.vue";

import {
  Blockquote,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Italic,
  Link,
  Strike,
  Underline
} from "tiptap-extensions";

export default {
  name: "createresourceform",
  components: {
    EditorContent,
    EditorMenuBar,
    EditorMenuButton
  },
  data() {
    return {
      resourceDataType: "",
      locations: [],
      resourceData: {
        title: "",
        location: "",
        createDate: null,
        type: "",
        description: "<p>This is an editable description of this resource</p>",
        howToAccess: "<p>This is an editable how to access of this resource</p>",
      },
      typeSelectorStyle: null,
      editor: new Editor({
        content: "<p>This is an editable description of this resource</p>",
        extensions: [
          new Blockquote(),
          new BulletList(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new HorizontalRule(),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Link(),
          new Bold(),
          new Italic(),
          new Strike(),
          new Underline()
        ],
        onUpdate: ({ getHTML }) => {
          // get new content on update
          this.resourceData.description = getHTML();
        }
      }),
      editor2: new Editor({
        content: "<p>This is an editable how to access of this resource</p>",
        extensions: [
          new Blockquote(),
          new BulletList(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new HorizontalRule(),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Link(),
          new Bold(),
          new Italic(),
          new Strike(),
          new Underline()
        ],
        onUpdate: ({ getHTML }) => {
          // get new content on update
          this.resourceData.howToAccess = getHTML();
        }
      })
    };
  },
  watch: {
    resourceDataType(newType, _) {
      this.resourceData.type = newType;

      if (this.typeSelectorStyle != null && this.resourceData.type != "") {
        this.typeSelectorStyle = {
          border: "1px solid #1CCF87",
          "border-radius": "0.375rem"
        };
      }
    }
  },
  mounted() {
    this.getLocations();
  },
  methods: {
    getLocations() {
      const self = this;

      firebase
        .firestore()
        .collection("locations/")
        .get()
        .then(function(querySnapshot) {
          const documents = querySnapshot.docs.map(doc => {
            const docData = doc.data();
            docData.id = doc.id;

            return docData;
          });

          self.locations = Object.values(documents);
        });
    },
    submit: function(event) {
      const form = document.getElementById("createResourceForm");

      //console.log("SUBBMITTED " + form.checkValidity());

      event.preventDefault();
      event.stopPropagation();

      form.classList.add("was-validated");

      if (form.checkValidity() && this.resourceData.type != "") {
        this.typeSelectorStyle = {
          border: "1px solid #FE6237",
          "border-radius": "0.375rem"
        };

        const rData = this.resourceData;
        const curOrgId = this.$store.state.usermain.curOrg.id;

        const finalResourceData = {
          title: rData.title,
          location: rData.location,
          createDate: new Date(),
          resourceType: rData.type,
          description: rData.description,
          howToAccess: rData.howToAccess,
          addedByOrg: curOrgId
        };

        console.log(finalResourceData);

        firebase
          .firestore()
          .collection(`organizations/${curOrgId}/resources/`)
          .add(finalResourceData)
          .then(ref => {
            if (ref.id) {
              $("#createResource").modal("hide");
              location.reload();
            }
          })
          .catch(function(error) {
            console.error(error);
          });
      }

      if (this.resourceData.type == "") {
        this.typeSelectorStyle = {
          border: "1px solid #FE6237",
          "border-radius": "0.375rem"
        };
      } else {
        this.typeSelectorStyle = {
          border: "1px solid #1CCF87",
          "border-radius": "0.375rem"
        };
      }
    }
  }
};
</script>

<style lang="scss">
.ProseMirror {
  text-align: initial;
  &:focus {
    outline: none;
  }
}
.editor {
  border-radius: 0.375rem;
  border: 1px solid #cad1d7;
}
</style>